import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { brandAssets } from "@/lib/brand/tokens";
import { getAllSetupFlows } from "@/data/setup/registry";

const SetupHubPage = () => {
  const flows = getAllSetupFlows();

  return (
    <div className="min-h-screen bg-genie-background text-[#222B45] flex flex-col">
      <div className="h-1 bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8]" />
      <header className="h-[68px] flex-shrink-0 border-b border-genie-border bg-white/90 backdrop-blur px-5 md:px-8 flex items-center">
        <img src={brandAssets.wordmark} alt="Help Genie" className="h-7 md:h-8 object-contain" />
      </header>

      <main className="flex-1 overflow-auto">
        <div className="mx-auto w-full max-w-5xl px-5 py-12 md:py-16">
          <p className="text-[11px] font-bold tracking-[1.6px] uppercase bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] bg-clip-text text-transparent">
            Help Genie Setup
          </p>
          <h1 className="mt-3 text-3xl md:text-4xl font-bold text-[#222B45] leading-tight">
            Build your genie in under a minute
          </h1>
          <p className="mt-4 max-w-2xl text-sm md:text-base text-[#64748B] leading-relaxed">
            Pick the setup that fits you. Answer a couple of simple questions and we'll build a genie that's
            ready to talk — no forms, no sign-up.
          </p>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {flows.map((flow) => (
              <Link
                key={flow.meta.slug}
                to={`/setup/${flow.meta.slug}`}
                className="group block p-[2px] rounded-2xl bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] shadow-lg shadow-genie-primary/10 transition-transform hover:scale-[1.02]"
              >
                <div className="h-full rounded-[14px] bg-white p-5 md:p-6 flex flex-col">
                  <div className="flex items-center justify-between">
                    <div className="h-16 w-16 rounded-2xl bg-genie-background border border-genie-border flex items-center justify-center overflow-hidden">
                      <img src={flow.meta.mascot} alt="" className="h-14 w-14 object-contain" />
                    </div>
                    <span className="rounded-full border border-genie-border bg-genie-background px-3 py-1 text-[11px] font-semibold text-gray-500">
                      {flow.meta.setupMinutes}
                    </span>
                  </div>
                  <h2 className="mt-4 text-lg font-bold text-[#222B45]">{flow.meta.name}</h2>
                  <p className="mt-2 flex-1 text-sm text-gray-600 leading-relaxed">{flow.meta.description}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-genie-primary">
                    Start setup
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default SetupHubPage;
